import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import reveal from './directives/reveal'


const app = createApp(App);

app.use(router);
app.use(store);
app.directive('reveal', reveal);
app.mount('#app');